/* eslint-disable jsx-a11y/alt-text, react/no-unescaped-entities */
import React from 'react'
import PrimaryHeader from '../../../../components/primary-header'
import {
  BackButton,
  Container,
  LogoImage,
  TermsContainer,
  WrapperHeader,
} from './styles'
import logoImage from '../../../../assets/png/logo-intro.png'
import back from '../../../../assets/svg/arrow-left-line.svg'

type IProps = {
  handleGoBack: () => void
}

function PagePolicyPrivacy({ handleGoBack }: IProps) {
  return (
    <>
      <PrimaryHeader
        style={{
          background: 'none',
          borderRadius: '0px 0px 40px 40px',
          borderBottom: '5px solid rgb(14, 150, 88)',
        }}
      >
        <WrapperHeader>
          <BackButton onClick={handleGoBack}>
            <img src={back} />
            &nbsp;Voltar
          </BackButton>
          <LogoImage src={logoImage} alt="Logo" />
        </WrapperHeader>
      </PrimaryHeader>
      <Container>
        <TermsContainer>
          <p>
            A presente "Política de privacidade" detalha como coletamos,
            utilizamos, compartilhamos e protegemos as informações pessoais que
            você fornece ao utilizar a plataforma Buscar Médicos Brasil,
            especialmente destacando nossos compromissos em relação à proteção
            de seus dados.
            <br />
            <br />
            Esta Política de Privacidade foi elaborada em conformidade com a Lei
            Federal n. 12.965 de 23 de abril de 2014 (Marco Civil da Internet) e
            com a Lei Federal n. 13.709, de 14 de agosto de 2018 (Lei Geral de
            Proteção de Dados Pessoais) e poderá ser atualizada e alinhada a
            novos entendimentos e aplicações normativas nacionais.
            <br />
            <br />
            Ao optar por utilizar nossa plataforma, você concorda com as
            práticas descritas nesta política. Recomendamos você ler atentamente
            nossos Termos e Políticas para garantir uma experiência confiável e
            segura.
          </p>
          <br />
          <br />
          <p>
            <strong>Considerandos</strong>
            <br />
            Considerando que o Usuário Médico é profissional inscrito nos
            quadros do Conselho Federal de Medicina (CFM) e possui interesse em
            receber oportunidades de plantões, consultas e demais serviços
            disponibilizados e oferecidos pelos Usuários Contratantes.
            <br />
            <br />
            O Usuário Contratante é uma empresa que atua no mercado de saúde e é
            reconhecida como Clínica, Hospital públicos e privados, Prefeituras
            e outros serviços de saúde e assistência à saúde devidamente
            cadastradas e habilitadas nos órgãos regulatórios responsáveis e
            possui interesse em ter acesso a um catálogo de contatos de médicos
            para contratá-los.
            <br />
            <br />
            A Buscar Médicos Brasil possui os meios necessários para
            apresentar aos Usuários Médicos tais oportunidades ofertadas pelos
            Usuários Contratantes, portanto estabelece a presente Política de
            Privacidade aos seus usuários.
          </p>
          <br />
          <br />
          <h2>Política de Privacidade - Buscar Médicos Brasil</h2>
          <p>
            <strong>Última atualização: 16 de maio de 2024</strong>
            <br />
            <br />
            A Buscar Médicos Brasil Compromete-se a proteger a sua
            privacidade e a garantir a segurança das suas informações pessoais.
            Esta Política de Privacidade detalha como coletamos, utilizamos,
            compartilhamos e protegemos os seus dados. Ao baixar, acessar ou
            utilizar a plataforma Buscar Médicos Brasil, você concorda com as
            práticas descritas nesta política.
            <br />
            <br />
          </p>

          <h3>1 - Informações Coletadas</h3>
          <p>
            Coletamos informações fornecidas durante o seu processo de registro
            na plataforma e nos comprometemos a utilizá-los para as finalidades
            declaradas, de forma transparente, lícita e leal, preservando a
            integridade dos usuários, conforme declarado nesta Política de
            Privacidade.
            <br />
            <br />
            Quanto aos dados coletados, temos:
            <br />
            <br />
            <strong>1.1 - Cadastro do Usuário Médico</strong>
            <br />
            Para acessar e utilizar a Plataforma, o Usuário Médico deve realizar
            o seu pré-cadastro por meio do preenchimento de formulário
            disponível na própria Plataforma, devendo informar:
            <br />
            <br />
            <strong>1.1.1 - Informações Pessoais</strong>
            <br />
            As informações pessoais são informações de identificação da sua
            pessoa e servem para que você possa ser identificado dentro da
            plataforma. As informaçòes Pessoais necessárias são:
            <br />
            <ul>
              <li>Primeiro nome;</li>
              <li>Sobrenome;</li>
              <li>
                Endereço - CEP, rua/avenida, número, bairro, cidade, estado e
                complementos;
              </li>
              <li>Foto de perfil.</li>
            </ul>
            <br />
            <strong>1.1.2 - Informações de contato</strong>
            <br />
            As informações de contato são informações relevantes para que
            Usuários Contratantes interessados em seu perfil possam entrar em
            contato com você para oferecer as oportunidades disponibilizadas.
            Dentro dos dados necessários, solicitamos:
            <ul>
              <li>Endereço de E-mail;</li>
              <li>Número de telefone.</li>
            </ul>
            <br />
            <strong>1.1.3 - Informações profissionais</strong>
            <br />
            As informações profissionais são relevantes para que os Usuários
            Contratantes possam ter conhecimento de suas principais
            especializações e qualificações, conquistas profissionais e
            acadêmicas, bem como preferências de atuação alinhado com as ofertas
            disponíveis, conectando você a outros usuários e às melhores
            oportunidades do mercado. Dentro dos dados necessários, solicitamos:
            <br />
            <ul>
              <li>
                Número de habilitação profissional junto ao Conselho Regional de
                Medicina (CRM);
              </li>
              <li>Especializações;</li>
              <li>Cidades em que deseja atuar;</li>
              <li>Disponibilidade de dias e horas que deseja atuar;</li>
              <li>Setor em que deseja atuar.</li>
            </ul>
            <br />
            <strong>1.4.4 - Informações para login</strong>
            <br />
            As informações de login são pessoais e intransferíveis, essas
            informações deverão ser mantidas em sigilo e serão utilizadas pelo
            Usuário para login. As informações necessárias para entrar e
            utilizar os serviços da plataforma são:
            <br />
            <ul>
              <li>E-mail;</li>
              <li>Senha de escolha do Usuário.</li>
            </ul>
            <br />
            <strong>1.2 - Cadastro dos Contratantes</strong>
            <br />
            Para acessar e utilizar a Plataforma, o Usuário Contratante deve
            realizar o seu pré-cadastro por meio do preenchimento de formulário
            disponível na própria Plataforma, devendo informar:
            <br />
            <br />
            <strong>1.2.1 - Informações da empresa</strong>
            <br />
            As informações da empresa são informações de identificação da
            empresa e servem para que você possa ser identificado dentro da
            plataforma. As informaçòes Pessoais necessárias são:
            <br />
            <ul>
              <li>Razão social;</li>
              <li>Nome fantasia;</li>
              <li>CNPJ;</li>
              <li>Site;</li>
              <li>Foto/logo de perfil;</li>
              <li>
                Endereço - CEP, rua/avenida, número, bairro, cidade, estado e
                complemento.
              </li>
            </ul>
            <strong>1.2.2 - Informações de contato</strong>
            <br />
            As informações de contato são informações relevantes para que
            Usuários Médicos interessados nas vagas ofertadas pelos Usuários
            Contratantes possam entrar em contato para tirar dúvidas específicas
            e alinhar sobre o serviço prestado:
            <ul>
              <li>E-mail;</li>
              <li>Número de telefone;</li>
            </ul>
            <br />
            <strong>1.2.3 - Informações para Login</strong>
            <br />
            As informações de login são pessoais e intransferíveis, essas
            informações deverão ser mantidas em sigilo e serão utilizadas pelo
            Usuário para login. As informações necessárias para entrar e
            utilizar os serviços da plataforma são:
            <ul>
              <li>E-mail;</li>
              <li>Senha.</li>
            </ul>
            <br />
            <strong>1.3 - Informações de registros e logs</strong>
            <br />
            Além desses dados, ambos os Usuários, Médicos e Contratantes,
            disponibilizarão dados como:
            <ul>
              <li>Informações de registros (Logs);</li>
              <li>Informações sobre dispositivos.</li>
            </ul>
            <br />
            Os dados mencionados neste item visam ser utilizados para as
            melhorias da plataforma e das soluções ofertadas.
            <br />
            <br />
            Alertamos ainda de que é única e exclusiva responsabilidade do
            Usuário verificar a veracidade e regularidade dos documentos e
            informações apresentadas e compartilhadas, não sendo da Buscar
            Médicos Brasil, em qualquer hipótese, responsável, direta ou
            indiretamente, por qualquer ato praticado pelo Usuário Médico e/ou
            pelo Usuário Contratante com relação a eventual fraude ou falsidade
            ideológica.
            <br />
            <br />
            <h3>2 - Direitos dos Usuários</h3>
            <p>
              A plataforma Buscar Médicos Brasil se compromete a manter o padrão
              exigido de segurança pelos órgãos regulatórios como a Autoridade
              Nacional de Proteção de Dados - ANPD e a Lei Geral de Proteção de
              Dados (Lei 13.709/18 - LGPD), bem como seus princípios declarados
              no artigo 6 e 7 da referida Lei:
              <ul>
                <li>
                  Finalidade: realização do tratamento para propósitos
                  legítimos, específicos, explícitos e informados ao titular,
                  sem possibilidade de tratamento posterior de forma
                  incompatível com essas finalidades;
                </li>
                <li>
                  Adequação: compatibilidade do tratamento com as finalidades
                  informadas ao titular, de acordo com o contexto do tratamento;
                </li>
                <li>
                  Necessidade: limitação do tratamento ao mínimo necessário para
                  a realização de suas finalidades, com abrangência dos dados
                  pertinentes, proporcionais e não excessivos em relação às
                  finalidades do tratamento de dados;
                </li>
                <li>
                  Livre acesso: garantia, aos titulares, de consulta facilitada
                  e gratuita sobre a forma e a duração do tratamento, bem como
                  sobre a integralidade de seus dados pessoais;
                </li>
                <li>
                  Qualidade dos dados: garantia, aos titulares, de exatidão,
                  clareza, relevância e atualização dos dados, de acordo com a
                  necessidade e para o cumprimento da finalidade de seu
                  tratamento;
                </li>
                <li>
                  Transparência: garantia, aos titulares, de informações claras,
                  precisas e facilmente acessíveis sobre a realização do
                  tratamento e os respectivos agentes de tratamento, observados
                  os segredos comercial e industrial;
                </li>
                <li>
                  Segurança: utilização de medidas técnicas e administrativas
                  aptas a proteger os dados pessoais de acessos não autorizados
                  e de situações acidentais ou ilícitas de destruição, perda,
                  alteração, comunicação ou difusão;
                </li>
                <li>
                  Prevenção: adoção de medidas para prevenir a ocorrência de
                  danos em virtude do tratamento de dados pessoais;
                </li>
                <li>
                  Não discriminação: impossibilidade de realização do tratamento
                  para fins discriminatórios ilícitos ou abusivos;
                </li>
                <li>
                  Responsabilização e prestação de contas: demonstração, pelo
                  agente, da adoção de medidas eficazes e capazes de comprovar a
                  observância e o cumprimento das normas de proteção de dados
                  pessoais e, inclusive, da eficácia dessas medidas.
                </li>
              </ul>
            </p>
            <br />
            <p>
              Sendo assim, os usuários, titulares dos dados, possuem o direito
              de acessar, corrigir, atualizar, portar e eliminar seus dados
              pessoais, de acordo com as disposições da Lei Geral de Proteção de
              Dados (Lei nº 13.709/2018) e demais regulamentações aplicáveis.
            </p>
            <br />
            <p>
              Para exercer tais direitos, os usuários deverão entrar em contato
              com a Buscar Médicos Brasil através dos canais de comunicação
              disponibilizados na plataforma.
            </p>
            <br />
            <p>
              A Buscar Médicos Brasil se compromete a fornecer uma resposta
              adequada, considerando a complexidade e a quantidade de
              solicitações recebidas. Em casos excepcionais em que a solicitação
              de exclusão de dados pessoais possa comprometer o cumprimento de
              obrigações legais ou contratuais, a Buscar Médicos Brasil
              informará ao titular dos dados os motivos que impedem o
              atendimento da solicitação.
            </p>
            <br />
            <p>
              Nos termos da legislação aplicável, a Buscar Médicos Brasil poderá
              reter certas informações quando necessárias para o cumprimento de
              obrigações legais, resolução de litígios, execução de contratos e
              outras finalidades legítimas.
            </p>
            <br />
            <p>
              A Buscar Médicos Brasil compromete-se a adotar medidas técnicas e
              organizacionais adequadas para garantir a proteção dos direitos
              dos titulares dos dados, incluindo a implementação de medidas de
              segurança para evitar acessos não autorizados, perda ou alteração
              dos dados pessoais.
            </p>
            <br />
            <h3>
              3 - Armazenamento das Informações e Procedimentos de Segurança
            </h3>
            <p>
              Os dados e informações compartilhadas pelos usuários são
              armazenadas nos servidores da Amazon Web Services (AWS), sendo
              estes co-responsáveis por proteger a infraestrutura que executa os
              serviços de armazenamento e proteção de dados.
            </p>
            <br />
            <p>
              A AWS implementa e mantém medidas de segurança técnica e
              organizacional aplicáveis a serviços de infraestrutura da Nuvem
              AWS em estruturas e certificações de garantia de segurança
              reconhecidas mundialmente, incluindo ISO/IEC 27001, ISO/IEC 27017,
              ISO/IEC 27018, PCI DSS Level 1 e SOC 1, 2 e 3. Essas medidas de
              segurança técnica e organizacional são validadas por auditores
              externos independentes e são projetadas para impedir o acesso não
              autorizado ao conteúdo de clientes ou a divulgação não autorizada
              desse conteúdo.
            </p>
            <br />
            <p>
              A Buscar Médicos Brasil é responsável pelo tratamento dos dados
              pessoais compartilhados na plataforma e mantém os termos e
              requisitos atualizados para que seus parceiros atuem em
              conformidade com as disposições da LGPD, ou seja, a Buscar Médicos
              Brasil exige de seus provedores de serviços as garantias adequadas
              de segurança e proteção dos dados armazenados em conformidade com
              a legislação.
            </p>
            <br />
            <p>
              A Buscar Médicos Brasil adotará medidas técnicas e organizacionais
              adequadas para garantir a segurança dos dados pessoais coletados,
              armazenados, processados e transmitidos, em conformidade com a
              legislação brasileira de proteção de dados, incluindo a Lei Geral
              de Proteção de Dados (LGPD).
            </p>
            <br />
            <p>
              Serão implementadas medidas de segurança da informação, tais como
              criptografia de dados, controle de acesso baseado em função,
              monitoramento de sistemas, e outras práticas reconhecidas como
              padrão de mercado para proteção de dados sensíveis.
            </p>
            <br />
            <p>
              Serão realizadas avaliações periódicas de risco e revisões de
              segurança para garantir a eficácia contínua das medidas de
              proteção de dados e para mitigar quaisquer ameaças à segurança da
              informação.
            </p>
            <br />
            <p>
              Os funcionários e prestadores de serviços da Buscar Médicos Brasil
              serão devidamente treinados e orientados sobre as práticas de
              segurança da informação e sua importância na proteção dos dados
              pessoais.
            </p>
            <br />
            <p>
              Em caso de identificação de incidentes de segurança que possam
              comprometer a proteção dos dados pessoais, a Buscar Médicos Brasil
              adotará procedimentos de resposta a incidentes, incluindo a
              notificação às autoridades competentes, como a ANPD, e aos
              titulares dos dados, conforme exigido pela legislação aplicável.
            </p>
            <br />
            <p>
              A Buscar Médicos Brasil se compromete a manter registros de todas
              as medidas de segurança implementadas, bem como de quaisquer
              incidentes de segurança e ações corretivas adotadas, a fim de
              demonstrar conformidade com as obrigações legais e garantir a
              transparência na gestão da segurança da informação.
            </p>
            <br />
            <strong>3.1. - Notificação de Incidentes de Segurança:</strong>
            <p>
              Em conformidade com a legislação brasileira de proteção de dados,
              especialmente a Lei Geral de Proteção de Dados (LGPD), a Buscar
              Médicos Brasil compromete-se a notificar prontamente às
              autoridades competentes e aos titulares dos dados em caso de
              incidente de segurança que possa comprometer a proteção dos dados
              pessoais.
            </p>
            <br />
            <p>
              A notificação de incidentes de segurança será realizada a partir
              da data em que a Buscar Médicos Brasil tomar conhecimento do
              incidente. Os titulares dos dados serão notificados quando o
              incidente de segurança representar um risco relevante ou dano para
              seus direitos e liberdades, conforme determinado pela avaliação de
              risco realizada pela empresa.
            </p>
            <br />
            <p>
              Além da notificação aos titulares dos dados, a empresa também
              notificará a Autoridade Nacional de Proteção de Dados (ANPD) e
              outras autoridades competentes, conforme exigido pela legislação
              aplicável.
            </p>
            <br />
            <p>
              A Buscar Médicos Brasil manterá registros de todos os incidentes
              de segurança, incluindo as notificações realizadas, as
              investigações conduzidas e as medidas corretivas adotadas, a fim
              de demonstrar conformidade com as obrigações legais e garantir a
              transparência na gestão da segurança da informação.
            </p>
            <br />
            <h3>4 - Uso das Informações</h3>
            <p>
              O uso de seus dados ou informações pela Buscar Médicos Brasil são
              limitados a melhorias da plataforma, personalização e melhoria de
              experiência dos usuários, levando em consideração o
              compartilhamento com prestadores de serviços terceirizados que se
              enquadrem em nossos requisitos de segurança, bem como será
              utilizado para comunicações, avisos e identificação entre usuários
              dentro da plataforma, conforme especificações dispostas nos itens
              abaixo:
            </p>
            <br />
            <strong>4.1 - Comunicação entre os Usuários:</strong>
            <p>
              Utilizamos as informações para facilitar a interação entre os
              Usuários (Médicos e Contratantes), permitindo uma comunicação e
              identificação eficiente, segura, com transparência, qualidade e
              agilidade.
            </p>
            <br />
            <strong>4.2 - Melhorias:</strong>
            <p>
              As métricas analisadas com os dados e informações coletados são
              importantes para que possamos melhorar a plataforma Buscar Médicos
              Brasil, trazendo atualizações de funcionalidades.
            </p>
            <br />
            <strong>4.3 - Personalização da Experiência e ofertas:</strong>
            <p>
              Personalizamos a experiência do usuário com base nas informações
              fornecidas, oferecendo atualizações, recomendações e ofertas
              personalizadas e relevantes, melhorando a usabilidade da
              plataforma para os usuários.
            </p>
            <br />
            <strong>4.4 - Comunicados da plataforma:</strong>
            <p>
              Utilizamos os seus dados de contato para enviar comunicados
              relacionados à prestação de serviços, atualizações da plataforma,
              ofertas especiais e informações importantes.
            </p>
            <br />
            <h3>5 - Compartilhamento de Informações</h3>
            <strong>5.1 - Entre Usuários:</strong>
            <p>
              Os dados e informações serão compartilhadas entre os Usuários
              (Médicos e Contratantes). Os dados compartilhados entre os
              Usuários será através dos próprios perfis dos Usuários, sendo
              eles:
            </p>
            <p>
              Pelos Usuários Médicos:
              <ul>
                <li>Informações pessoais;</li>
                <li>Informações de contato;</li>
                <li>Informações profissionais.</li>
              </ul>
            </p>
            <br />
            <p>
              Pelos Usuários Contratantes:
              <ul>
                <li>Informações da empresa;</li>
                <li>Informações de contato.</li>
              </ul>
            </p>
            <br />
            <p>
              Ou seja, com exceção das informações de logins descritas nos itens
              "1.1.4", "1.2.3" e "1.3", as demais informaçòes poderão ser
              compartilhadas entre outros usuários, sejam eles Médicos ou
              Contratantes, para facilitar a contratação entre os Usuários, de
              forma transparente e otimizada.
            </p>
            <br />
            <strong>5.2 - Entre terceiros:</strong>
            <p>
              Respeitamos os limites legais e as definições trazidas nesta
              Política de Privacidade, e levando em consideração a extensão de
              nossas atividades, os seus dados e informações poderão ser
              compartilhados com:
              <ul>
                <li>
                  Fornecedores de tecnologia parceiros, no Brasil e exterior,
                  para prover a infraestrutura técnica necessária à oferta das
                  soluções da plataforma;
                </li>
                <li>
                  Instituições autorizadas pelo Banco Central do Brasil e
                  integrantes do mercado de meios de pagamentos que auxiliam a
                  Buscar Médicos Brasil na prestação do serviço ofertado
                  (parceiros de pagamento)
                </li>
                <li>
                  Terceiros que prestem serviços para a Buscar Médicos Brasil,
                  com fins a manutenção da segurança dos Usuários e das soluções
                  ofertadas pela Buscar Médicos Brasil, inclusive de antifraude.
                </li>
                <li>
                  Autoridades competentes como Conselho Federal de Medicina,
                  Poder Judiciário e outros autorizados por estes, sempre que
                  cabível, de forma pontual, para apurar possíveis fraudes em
                  casos específicos.
                </li>
              </ul>
            </p>
            <br />
            <strong>5.3 - Parceiros de Pagamento:</strong>
            <p>
              Para processamento de pagamentos referente a assinatura dos planos
              da Buscar Médicos Brasil, compartilhamos informações financeiras
              com parceiros de pagamento de forma segura e criptografada.
            </p>
            <br />
            <p>
              Os dados coletados pela empresa parceira que será responsável pelo
              recebimento de valores será única e exclusivamente utilizados para
              a finalidade específica de realizar pagamentos e renovações
              devidamente contratadas, sendo vedado qualquer outro uso por nós
              ou por este parceiro.
            </p>
            <br />
            <p>
              Dentro de nossas exigências, visamos sempre manter os dados
              seguros e criptografados, com acesso monitorado e restrito aos
              controladores e operadores, assim definidos no artigo 5 da LGPD,
              sendo necessário a realização, quando encerrado a conta, da
              exclusão dos dados e informações de maneira segura no âmbito e nos
              limites técnicos das atividades, conforme disposto no artigo 16 da
              LGPD.
            </p>
            <br />
            <p>
              A Buscar Médicos Brasil ainda, visando resguardar os dados dos
              Usuários, exige que o parceiro de pagamento seja,
              obrigatoriamente, regulado e supervisionado pelo Banco Central do
              Brasil, e, por esse motivo, deve guardar estrita observância aos
              normativos regulatórios aplicáveis, inclusive aqueles que impõem
              obrigações relativas à coleta, armazenamento e descarte de Dados.
            </p>
            <br />
            <p>
              A qualquer momento nossos Usuários poderão acessar e verificar a
              política de privacidade apresentada por nosso parceiro de
              pagamento.
            </p>
            <br />
            <strong>5.4 - Cumprimento Legal:</strong>
            <p>
              Não incorrerá em violação a esta política de privacidade o
              compartilhamento de informações sob as quais recaia obrigação
              legal, regulatória e/ou judicial, hipótese em que devem ser
              fornecidas exclusivamente as informações necessárias para o
              cumprimento da obrigação ou decisão judicial.
            </p>
            <br />
            <h3>6 - Segurança e Retenção de Dados</h3>
            <strong>6.1 - Medidas de Segurança:</strong>
            <p>
              Implementamos medidas de segurança físicas, técnicas e
              administrativas para proteger as informações contra acesso não
              autorizado, uso indevido ou divulgação.
            </p>
            <br />
            <strong>6.2 - Retenção de Dados:</strong>
            <p>
              Retemos informações pessoais pelo prazo de até 5 anos após o
              encerramento de sua conta, para que possamos oferecermos novas
              soluções e promoções para o usuário, ou até mesmo utilizá-las como
              métricas e históricos para as manutenções e melhorias de nossa
              plataforma.
            </p>
            <br />
            <h3>7 - Seus Direitos e Escolhas</h3>
            <strong>7.1 - Acesso e Atualização:</strong>
            <p>
              Você pode acessar e atualizar suas informações de perfil a
              qualquer momento através das "configurações de perfil" da sua
              conta.
            </p>
            <br />
            <strong>7.2 - Cancelamento da Conta:</strong>
            <p>
              Se você desejar encerrar sua conta, você terá a opção de deletá-la
              através da própria plataforma, na aba de edição do seu perfil.
            </p>
            <br />
            <p>
              Neste ato, seus dados poderão ser excluídos de nossos bancos de
              dados, caso você opte por excluí-los, caso contrário eles serão
              mantidos pelo prazo de 5 anos para a realização de novas ofertas e
              análise de métricas da plataforma. Reforçamos que seus dados não
              serão compartilhados com terceiros neste período.
            </p>
            <br />
            <strong>7.3 - Preferências de Comunicação:</strong>
            <p>
              Você pode gerenciar suas preferências de comunicação, optando por
              não receber determinadas mensagens da Buscar Médicos Brasil,
              através de e-mail, WhatsApp ou SMS, através dos meios de contatos
              oficiais da Buscar Médicos Brasil.
            </p>
            <br />
            <h3>8 - Alterações nesta Política</h3>
            <strong>8.1 - Atualizações:</strong>
            <p>
              A Buscar Médicos Brasil se reserva no direito de atualizar esta
              Política de Privacidade periodicamente. Os Usuários serão
              notificados com antecedência sobre alterações significativas
              através da plataforma e terão de aceitar os novos termos e
              políticas quando estas ocorrerem.
            </p>
            <br />
            <p>
              É recomendado que os Usuários consultem regularmente este Aviso de
              Privacidade para estarem sempre atualizados com relação ao
              Tratamento de Dados pela Buscar Médicos Brasil.
            </p>
            <br />
            <strong>8.2 - Revisões:</strong>
            <p>
              A Buscar Médicos Brasil compromete-se a realizar revisões
              periódicas desta política de privacidade para garantir sua
              conformidade contínua com a legislação brasileira de proteção de
              dados, incluindo a Lei Geral de Proteção de Dados (LGPD), e para
              refletir as melhores práticas de segurança da informação.
            </p>
            <br />
            <p>
              As revisões serão realizadas pelo menos anualmente, ou sempre que
              houver alterações significativas no ambiente operacional da
              empresa, nas práticas de processamento de dados ou na legislação
              relevante.
            </p>
            <br />
            <p>
              Durante o processo de revisão, serão identificadas e avaliadas
              quaisquer lacunas ou áreas de melhoria na política de privacidade,
              com o objetivo de garantir a eficácia contínua das medidas de
              proteção de dados e a conformidade com as normas legais e
              regulamentares. Os resultados das revisões serão documentados e
              incorporados à política de privacidade atualizada, que será
              disponibilizada aos funcionários, prestadores de serviços,
              titulares dos dados e outras partes interessadas relevantes.
            </p>
            <br />
            <p>
              A Buscar Médicos se compromete a manter registros das revisões
              realizadas, incluindo as datas das revisões, as alterações
              implementadas e as justificativas para tais alterações, a fim de
              demonstrar conformidade com as obrigações legais e garantir a
              transparência na gestão da política de privacidade e proteção de
              dados.
            </p>
            <br />
            <h3>9 - Contato</h3>
            <strong>9.1 - Dúvidas e Comentários:</strong>
            <p>
              Se você tiver dúvidas ou comentários sobre esta Política de
              Privacidade, entre em contato conosco através dos meios
              disponibilizados na plataforma.
            </p>
            <br />
            <p>
              Ao utilizar a Buscar Médicos Brasil, você concorda com os termos
              desta Política de Privacidade. Encorajamos a leitura atenta e
              regular desta política para se manter informado sobre como
              protegemos suas informações.
            </p>
          </p>
        </TermsContainer>
      </Container>
    </>
  )
}

export default PagePolicyPrivacy
